import React, { useEffect, useCallback, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Button,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    DragDropContext,
    Droppable,
    Draggable
} from "@hello-pangea/dnd";
import { IoClose } from "react-icons/io5";
import { CrearSliderPortadaInicio } from "./CrearSlider";
import { EditarSliderPortadaSelecion } from "./EditarSliderSelecion";
import "../../../css/Administrador/FuncionesGenerales.css"
import { useUserAdmin } from "../../../admin/UserContext";

export const InfoPortadaAdminInicio = () => {
    const { Token } = useUserAdmin();
    const [sliders, setSliders] = useState([]);
    const [ModalCrear, setModalCrear] = useState(false)
    const [ModalEditar, setModalEditar] = useState(false)
    const [SliderSelecion, setSliderSelecion] = useState([])
    const backendURL = process.env.REACT_APP_BACKEND_URL;

    const handleAbrirModalEditar = (id) => {
        setSliderSelecion(id)
        setModalEditar(true);
    };
    const handleAbrirCrearSlider = () => {
        setModalCrear(true);
    };

    const fetchSliders = useCallback(async () => {
    try {
      const response = await axios.get(`${backendURL}/api/all/banner`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setSliders(response.data.data);
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [Token, backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {
    if (Token) {
      fetchSliders();
    }
  }, [Token, fetchSliders]);

    const handleDragEnd = async (result) => {
        if (!result.destination) return;

        const reordered = Array.from(sliders);
        const [movedItem] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, movedItem);

        setSliders(reordered);

        try {
            // Enviar cada nueva posición al backend
            await Promise.all(
                reordered.map((slider, index) =>
                    axios.post(`${backendURL}/api/bannerUpdate/${slider.id}`, {
                        posicion: index + 1
                    }, {
                        headers: {
                            Authorization: `Bearer ${Token}`,
                        }
                    })
                )
            );
            await fetchSliders()
        } catch (error) {
            console.error("Error al actualizar las posiciones:", error);
        }
    };



    const handleDelete = async (id) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar este banner?')) {
            try {
                 await axios.delete(`${backendURL}/api/banners/eliminar/${id}`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            });
            
                fetchSliders();
            } catch (error) {
                console.error("Error al eliminar el banner:", error);
                alert("Ocurrió un error al eliminar el banner.");
            }
        }
    };
    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom sx={{ color: "#585857", fontWeight: 600 }}>
                Portada Slider Inicio
            </Typography>

            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAbrirCrearSlider}
                sx={{
                    color: "#fff",
                    background: "#5E487B",
                    textTransform: "capitalize",
                    marginTop: "20px",
                    marginBottom: "30px"
                }}
            >
                Crear nuevo slider
            </Button>

            <TableContainer component={Paper} sx={{ background: '#b2dfdb' }}>
                {sliders.length === 0 ? (
                    <Box p={3} textAlign="center" >
                        <Typography variant="subtitle1" sx={{ color: "#888" }}>
                            No hay sliders agregados.
                        </Typography>
                    </Box>
                ) : (
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="slider-table">
                            {(provided) => (
                                <Table {...provided.droppableProps} ref={provided.innerRef} sx={{ color: '#585857' }}>
                                    <TableHead sx={{ backgroundColor: '#80cbc4' }}>
                                        <TableRow>
                                            <TableCell sx={{ color: '#585857' }}>Posición</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Imagen fondo</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Imagen logo</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Imagen texto</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Imagen máquina</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sliders.map((slider, index) => (
                                            <Draggable key={slider.id} draggableId={slider.id.toString()} index={index}>
                                                {(provided, snapshot) => (
                                                    <TableRow
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        sx={{
                                                            background: snapshot.isDragging ? "#e0e0e0" : "#b2dfdb",
                                                            cursor: "grab"
                                                        }}
                                                    >
                                                        <TableCell sx={{ color: '#585857' }}>{slider.posicion} </TableCell>
                                                        <TableCell>
                                                            {slider.imagen_fondo && (
                                                                <img
                                                                    src={`${backendURL}/${slider.imagen_fondo}`}
                                                                    alt="Fondo"
                                                                    style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {slider.imagen_logo && (
                                                                <img
                                                                    src={`${backendURL}/${slider.imagen_logo}`}
                                                                    alt="Logo"
                                                                    style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {slider.imagen_texto && (
                                                                <img
                                                                    src={`${backendURL}/${slider.imagen_texto}`}
                                                                    alt="Texto"
                                                                    style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {slider.imagen_maquina && (
                                                                <img
                                                                    src={`${backendURL}/${slider.imagen_maquina}`}
                                                                    alt="Máquina"
                                                                    style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                         
                                                        <TableCell>
                                                            <Button
                                                                size="small"

                                                                onClick={() => handleAbrirModalEditar(slider.id)}
                                                                startIcon={<EditIcon />}
                                                                sx={{ marginRight: 1, background: '#ffcc80', color: '#fff', textTransform: "capitalize" }}
                                                            >
                                                                Editar
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                onClick={() => handleDelete(slider.id)}
                                                                startIcon={<DeleteIcon />}
                                                                sx={{ marginRight: 1, background: '#b71c1c', color: '#fff', textTransform: "capitalize" }}
                                                            >
                                                                Eliminar
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </TableBody>
                                </Table>
                            )}
                        </Droppable>
                    </DragDropContext>
                )}
            </TableContainer>

            {/* modal crear slider */}
            <Modal open={ModalCrear} onClose={() => setModalCrear(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalCrear(false)}>
                        <IoClose />
                    </section>
                    <CrearSliderPortadaInicio fetchSliders={fetchSliders} onclose={() => setModalCrear(false)} />

                </Box>
            </Modal>
            {/* Modal editar */}
            <Modal open={ModalEditar} onClose={() => setModalEditar(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalEditar(false)}>
                        <IoClose />
                    </section>
                    <EditarSliderPortadaSelecion fetchSliders={fetchSliders} slider={SliderSelecion} onclose={() => setModalEditar(false)} />

                </Box>
            </Modal>
        </Box>
    );
};